export const BUDGET_OPTIONS = [
  { label: '$1,000 — $5,000', value: '1k_to_5k' },
  { label: '$5,000 — $10,000', value: '5k_to_10k' },
  { label: '$10,000 — $20,000', value: '10k_to_20k' },
  { label: '$20,000 — $50,000', value: '20k_to_50k' },
  { label: '$50,000 — $100,000', value: '50k_to_100k' },
  { label: '$100,000+', value: '100k_plus' },
];
